<!------------------------------

      Page Actions

------------------------------->
<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.client_admin"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="toggleSideBar(); selectedApiKey = null;"
    sbTooltip="{{ 'lang.globals.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="400">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-api-key-edit [apiKey]="selectedApiKey"
                        (apiKeyChanged)="editApiKey($event)"></sb-page-api-key-edit>
</ng-template>

<!------------------------------

       Table Wrapper

 ------------------------------->
<div class="tw-min-h-[500px]">
  <sb-table-wrapper-new
    headline="{{'lang.globals.apiKeys' | translate}}"
    [itemsData]="apiKeys"
    (paginationChange)="requestDebounced($event)"
    [loading]="loading()"
    [itemName]="'apiKeys'">

    <!------------------------------

         Header More

    ------------------------------->

    <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
      <sb-filter-panel
        (filterChange)="applyFiltering($event)"
        [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
        [config]="filterConfig"
      >

      </sb-filter-panel>
    </div>
    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>
      <tr>
        <th>{{ 'lang.globals.identifier' | translate }}</th>
        <th>{{ 'lang.globals.name' | translate }}</th>
        <th>{{ 'lang.globals.expiredDate' |translate }}</th>
        <th>{{ 'lang.globals.createdAt' |translate }}</th>
        <th class="sticky-col last-col">
          {{ 'lang.globals.action' | translate }}
        </th>
      </tr>
    </ng-template>
    <!------------------------------

        Table Body

    ------------------------------->


    <ng-template #tbody let-data>
      @let apiKey = identification(data);
      <tr>
        <td>{{ apiKey.identifier }}</td>
        <td>{{ apiKey.name ?? '-' }}</td>
        <td>{{ apiKey.expiry?.toString() | date:'dd.MM.yy HH:mm' }}</td>
        <td>
          {{ apiKey.createdAt?.toString() | date:'dd.MM.yy HH:mm' }}
        </td>
        <td class="tr bw sticky-col last-col">
          <sb-split-button
            [splitButtonItems]="data.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(data, $event)"
          ></sb-split-button>
        </td>
      </tr>
    </ng-template>

  </sb-table-wrapper-new>
</div>
